import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontDisplay, hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => {
  return createStyles({
    tabsScrollWrapper: {
      position: 'relative',
      margin: '-2px 0',
    },

    tabsInline: {
      '& .MuiTabs-scroller': {
        zIndex: 1,
        borderRadius: 0,
        border: 'none',
        padding: '2px 0',
        overscrollBehaviorX: 'contain',
        '&::after': {
          content: '""',
          display: 'block',
          height: 1,
          width: '100%',
          backgroundColor: theme.color.greys[15],
        },
      },
      '& .MuiTabs-flexContainer': {
        width: 'max-content',
        minWidth: '100%',
        background: theme.color.greys[0],
        padding: '0 16px',
        [theme.breakpoints.down('sm')]: {
          padding: 0,
        },
      },
    },

    tabs__indicator: {
      backgroundColor: theme.color.oranges[50],
      position: 'absolute',
      height: 3,
      zIndex: 4,
      bottom: 2,
    },

    scrollArrow: {
      position: 'absolute',
      top: 9,
      bottom: 0,
      zIndex: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      backgroundColor: hexToRgbA(theme.color.greys[0], 0.8),
      '&:focus-visible': {
        outline: `2px solid ${theme.color.greys[80]}`,
      },
    },

    scrollArrowLeft: {
      left: -1,
    },

    scrollArrowRight: {
      right: -1,
    },

    scrollArrowIcon: {
      width: 16,
      height: 16,
      flexShrink: 0,
      color: theme.color.greys[80],
    },

    item: {
      padding: '16px 24px',
      font: fontDisplay('normal', theme.fontSize.base, 24),
      textTransform: 'initial',
      minWidth: 0,
      background: theme.color.greys[0],
      position: 'relative',
      opacity: 'unset',
      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: hexToRgbA(theme.color.greys[80], 0.08),
          zIndex: 4,
        },
      },
      '&:active': {
        backgroundColor: hexToRgbA(theme.color.greys[80], 0.16),
      },
      '&.Mui-focusVisible': {
        outline: `2px solid ${theme.color.greys[80]}`,
        zIndex: 3,
        '&.Mui-selected': {
          zIndex: 2,
        },
      },
      [theme.breakpoints.down('sm')]: {
        padding: 8,
      },
    },
  });
}, { name: 'Tabs', index: StylesIndexInjections.UI_ATOMS });
